import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "../button";
import { Calendar } from "../calendar";
import { Field, FieldError } from "../field";
import { cn } from "../lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../popover";
import { useFieldContext } from "./form-context";

export function DateField() {
	const field = useFieldContext<string>();

	const isInvalid = field.store.state.meta.isTouched && !field.store.state.meta.isValid;

	const [open, setOpen] = useState(false);

	return (
		<Field data-invalid={isInvalid}>
			<Popover onOpenChange={setOpen} open={open}>
				<PopoverTrigger
					render={
						<Button
							className={cn(
								"w-full cursor-pointer justify-start text-left font-normal",
								!field.store.state.value && "text-muted-foreground",
							)}
							id={field.name}
							variant="outline"
						>
							<CalendarIcon className="mr-2 size-4" />
							{field.store.state.value
								? format(field.store.state.value, "PPP")
								: "Pick a date"}
						</Button>
					}
				/>
				<PopoverContent align="start" className="w-auto overflow-hidden p-0">
					<Calendar
						captionLayout="dropdown"
						disabled={{
							before: new Date(),
						}}
						mode="single"
						onSelect={(date) => {
							if (date) {
								field.handleChange(date.toLocaleString());
							}
							setOpen(false);
						}}
					/>
				</PopoverContent>
			</Popover>
			{isInvalid && <FieldError errors={field.store.state.meta.errors} />}
		</Field>
	);
}
